import { Link, useNavigate } from "react-router-dom";
import { useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Reaptcha from "reaptcha";

import { HTTP } from "../../http/http-common";

const CustomerSupport = ({settings}) => {
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState(null);
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);
  const navigate = useNavigate();

  const verify = () => {
    captchaRef.current.getResponse().then((res) => {
      setCaptchaToken(res);
    });
  };

  const expired = () => {
    captchaRef.current.reset();
    setCaptchaToken(null);
  };

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      phone: "",
      comments: "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("Firstname is required!"),
      last_name: Yup.string().required("Lastname is required!"),
      phone: Yup.string()
        .max(10, "maximum 10 numbers")
        .required("Phone is required!"),
      comments: Yup.string()
        .min(10, "Mininum 10 characters")
        .max(200, "Maximum 200 characters")
        .required("Comments is required!"),
    }),
    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      HTTP.post("/contactus", values)
        .then((res) => {
          setInfo(res.message);
          captchaRef.current.reset();
          setCaptchaToken(null);
          resetForm({ values: "" });
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    },
  });

  return (
    <>
      <section className="inner-page  d-flex align-items-center justify-content-center">
        <div className="overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xl-12">
              <nav aria-label="breadcrumb">
                <h4 className="main-heading text-capitalize text-center mb-0">
                  Customer Support
                </h4>
                <ol className="breadcrumb d-flex align-items-center justify-content-center">
                  <li className="breadcrumb-item">
                    <Link to={"/"} className="text-white">
                      Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Customer Support
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>
      <section className="inner-course-detail section-padding">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-8 offset-xl-2">
              <div className="phone-number mb-md-3 mb-3 mb-xl-4">
                <h2 className="big-heading text-capitalize mb-2 mb-md-2">
                  Metro Traffic School
                </h2>
                {/* <a href="tel:(305) 513-0063">{settings.site_phone}</a> */}
                <a href="tel:1-888-41-METRO" className="mx-2">
                  <strong>{settings.site_phone_2}</strong>
                </a>
                {/* eslint-disable-next-line no-undef */}
                <i onClick={() => Chatra('openChat', true)} className='fas fa-comment-dots text-white chat'></i>
              </div>
              <div className="form-section">
                <div className="form-heading text-capitalize">
                  send us a message
                  <i
                    onClick={() => navigate(-1)}
                    className="fa fa-window-close close"
                    aria-hidden="true"
                  ></i>
                </div>
                <div>
                  <h4 style={{ color: "green" }}>{info}</h4>
                </div>
                <form onSubmit={formik.handleSubmit}>
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 mb-4">
                      <input
                        id="first_name"
                        type="text"
                        className="form-control"
                        placeholder="First Name"
                        aria-label="first_name"
                        value={formik.values.first_name}
                        onChange={formik.handleChange}
                        style={{
                          borderColor:
                            formik.errors.first_name && formik.touched.first_name
                              ? "red"
                              : "",
                        }}
                      />
                      {formik.errors.first_name && formik.touched.first_name && (
                        <p className="text-danger">{formik.errors.first_name}</p>
                      )}
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 mb-4">
                      <input
                        id="last_name"
                        type="text"
                        className="form-control"
                        placeholder="Last Name"
                        aria-label="last_name"
                        value={formik.values.last_name}
                        onChange={formik.handleChange}
                        style={{
                          borderColor:
                            formik.errors.last_name && formik.touched.last_name
                              ? "red"
                              : "",
                        }}
                      />
                      {formik.errors.last_name && formik.touched.last_name && (
                        <p className="text-danger">{formik.errors.last_name}</p>
                      )}
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4">
                      <input
                        id="phone"
                        type="text"
                        className="form-control"
                        placeholder="Phone"
                        aria-label="Phone"
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                        style={{
                          borderColor:
                            formik.errors.phone && formik.touched.phone
                              ? "red"
                              : "",
                        }}
                      />
                      {formik.errors.phone && formik.touched.phone && (
                        <p className="text-danger">{formik.errors.phone}</p>
                      )}
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4">
                      <textarea
                        className="form-control"
                        id="comments"
                        rows="3"
                        placeholder="Comments"
                        value={formik.values.comments}
                        onChange={formik.handleChange}
                        style={{
                          borderColor:
                            formik.errors.comments && formik.touched.comments
                              ? "red"
                              : "",
                        }}
                      ></textarea>
                      {formik.errors.comments && formik.touched.comments && (
                        <p className="text-danger">{formik.errors.comments}</p>
                      )}
                    </div>
                    <div className="col-12 col-sm-6 col-md-6  col-lg-6 col-xl-6 col-xxl-6 mb-3 mb-md-3">
                      <Reaptcha
                        sitekey={import.meta.env.VITE_SITE_KEY}
                        ref={captchaRef}
                        onVerify={verify}
                        onExpire={expired}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-md-6  col-lg-6 col-xl-6 col-xxl-6 d-flex align-items-center justify-content-end">
                      <button
                        type="submit"
                        disabled={!captchaToken}
                        className="btn yellow-btn  d-flex align-items-center justify-content-center"
                      >
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CustomerSupport;
